import {
  compose, pure, withHandlers, withProps, withStateHandlers,
} from 'recompose';
import { withTranslation } from 'react-i18next';
import { equals } from 'ramda';

import FiltersRow from './filtersRow';
import { withWindowWidth } from '../../../../utils/enchancers';

const sortParams = {
  recent: {
    order: 'desc',
    sortBy: 'created_at',
  },
  old: {
    order: 'asc',
    sortBy: 'created_at',
  },
};

const onChangeSortingHandler = ({ onSortBy }) => ({ val: { order, sortBy } }) => {
  onSortBy({ order, sort: sortBy });
};

const onChangeSortingOnButtonHandler = ({ onSortBy, toggleMobileFiltersHandler }) => (e) => {
  const { target: { name } } = e;
  const { order, sortBy } = sortParams[name];
  onSortBy({ order, sort: sortBy });
  toggleMobileFiltersHandler();
};

const getSortValue = (order, sort) => {
  if (equals('created_at', sort)) {
    return equals('desc', order) ? 0 : 1;
  }
  return null;
};


const enhance = compose(
  withTranslation(['projects']),
  pure,
  withWindowWidth(),
  withProps(({ order, sort }) => ({
    sortingByDate: getSortValue(order, sort),
  })),
  withStateHandlers({
    areMobileFiltersOpen: false,
  }, {
    toggleMobileFiltersHandler:
      ({ areMobileFiltersOpen }) => () => ({ areMobileFiltersOpen: !areMobileFiltersOpen }),
  }),
  withHandlers({
    onChangeSorting: onChangeSortingHandler,
    onChangeSortingOnButton: onChangeSortingOnButtonHandler,
  }),
);
export default enhance(FiltersRow);
